import React from "react";
import AgreementsAnalysisModule from "./agreementsAnalysis";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Agreements",
  moduleList: [AgreementsAnalysisModule],
  hideConfigurator: true
};

const AgreementsPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default AgreementsPage;
